/**
 * Ratios between various entities.
 * tag: 2472
 * @readonly
 * @enum {number} (int)
 */
export enum MDStatisticRatioType {
  BuyersToSellers = 1,
  UpticksToDownticks = 2,
  MarketMakerToNonMarketMaker = 3,
  AutomatedToNonAutomated = 4,
  OrdersToTrades = 5,
  QuotesToTrades = 6,
  OrdersAndQuotesToTrades = 7,
  FailedToTotalTradedValue = 8,
  BenefitsToTotalTradedValue = 9,
  FeesToTotalTradedValue = 10,
  TradeVolumeToTotalTradedVolume = 11,
  OrdersToTotalNumberOrders = 12,
}
